import { DesignIcon } from '@monorepo/nova-icons';
import { Box, IconButton, Tooltip } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

interface StyledDiscordButtonWrapperProps {
  isEnabled: boolean;
  isDesktop: boolean;
}

export const StyledDiscordButtonWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDesktop' && prop !== 'isEnabled',
})<StyledDiscordButtonWrapperProps>(({ isDesktop }) => ({
  display: 'inline-flex',
  position: 'relative',
  marginLeft: !isDesktop ? '16px' : '24px',
}));

interface StyledDiscordIconButtonProps {
  isMobile: boolean;
  isEnabled: boolean;
}

export const StyledDiscordIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'isEnabled',
})<StyledDiscordIconButtonProps>(({ theme, isMobile, isEnabled }) => ({
  width: isMobile ? 28 : 32,
  height: isMobile ? 28 : 32,
  minWidth: 'unset',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: isEnabled ? 'pointer' : 'not-allowed',
  position: 'relative',

  ...(isEnabled && {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(
          90deg,
          transparent 0%,
          ${theme.palette.primary.main}33 25%,
          ${theme.palette.primary.main}66 50%,
          ${theme.palette.primary.main}33 75%,
          transparent 90%
        )`,
      backgroundSize: '200% 100%',
      backgroundRepeat: 'no-repeat',
      animation: 'shineAnimation 4s linear infinite',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      '@keyframes shineAnimation': {
        '0%': {
          backgroundPosition: '200% center',
        },
        '100%': {
          backgroundPosition: '-200% center',
        },
      },
    },
  }),
}));

export const StyledDiscordIcon = styled('div')({
  width: '100%',
  height: '100%',
  fontSize: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledDiscordTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    maxWidth: 270,
  },
});

interface StyledDiscordDesignIconProps {
  isEnabled: boolean;
}

export const StyledDiscordDesignIcon = styled(DesignIcon, {
  shouldForwardProp: (prop) => prop !== 'isEnabled',
})<StyledDiscordDesignIconProps>(({ theme, isEnabled }) => ({
  // DiscordDisabled.icon.svg has white logo on grey circle.
  // For disabled state in dark mode, invert colors (white -> black).
  // Grey circle stays relatively unchanged by invert filter.
  ...(!isEnabled &&
    theme.palette.mode === 'dark' && {
      filter: 'invert(1)',
    }),
}));
